import
  axios
from 'axios';

import
  md5
from 'md5';

import {
  JourneyProvider
} from '@vodacom/web-common';

import {
  CacheStrategy
} from '../constants';

import {
  cleanResponse
} from '../helpers';

const COMMON_HEADERS = {
  'x-api-channel': 'connectU'
};

export class AppState {
  constructor(context) {
    this.context = context;
  }

  static with(context) {
    return new WebSessionState(context);
  }

  isValidKey(key) {
    return typeof key === 'string' && key.length;
  }

  generateContextKey(key) {
    return `${this.context}_${md5(key)}`;
  }

  async makeServiceCall(
    url,
    {
      method,
      headers = {},
      queryParams = {},
      bodyParams = {},
      cacheStrategy = CacheStrategy.CacheFirst,
      cacheKey,
      callback = () => {},
      mapper
    }
  ) {
    const params = {
      method,
      url,
      headers: {
        ...COMMON_HEADERS,
        ...headers
      },
      params: {
        ...queryParams
      },
      data: {
        ...bodyParams
      },
      cacheStrategy,
      cacheKey,
      mapper
    };

    const cachedResponse = this.getItem(cacheKey, null);

    if (cacheStrategy !== CacheStrategy.None && cacheStrategy !== CacheStrategy.NetworkFirst && !cachedResponse) {
      cacheStrategy = CacheStrategy.NetworkFirst;
    }

    switch (cacheStrategy) {

      case CacheStrategy.None:
        return this.makeRequest(params);

      case CacheStrategy.NetworkFirst:
        return this.makeRequest(params).then((res) => {
          return res?.ok
            ? res
            : cachedResponse;
        });

      case CacheStrategy.CacheFirst:
        this.makeRequest(params).then((res) => {
          if (res?.ok) {
            callback(res);
          }
        });
        return cachedResponse;

      case CacheStrategy.CacheOnly:
        return cachedResponse;

      default:
        throw new Error(
          `${cacheStrategy} is not a valid Cache Strategy! Pick one of: ${Object.keys(
            CacheStrategy
          ).join(',')}`
        );
    }
  }

  async makeRequest(params) {
    return axios(params)
      .then(cleanResponse)
      .then(res => {

        if (params.mapper && typeof params.mapper === 'function' && res.ok && res.result) {
          return {
            ...res,
            result: params.mapper(res.result)
          };
        }

        return res;
      })
      .then((res) => {

        if (res.ok && params.cacheStrategy !== CacheStrategy.None) {
          this.setItem(params.cacheKey, res);
        }

        return res;
      })
      .catch(error => {

        if (error.response?.data?.result?.message === 'Please provide a valid ID.') {

          JourneyProvider.clearAll();
        }

        return Promise.reject(error);
      });
  }
}

export class WebSessionState extends AppState {
  //  TODO: fallback if storage undefined
  constructor(context) {
    super(context);
    this.sessionStorage = window.sessionStorage;
  }

  setItem(key, value) {
    if (!this.isValidKey(key) || value === undefined || !value) {
      return;
    }

    this.sessionStorage.setItem(
      this.generateContextKey(key),
      JSON.stringify(value)
    );
  }

  getItem(key, fallback = null) {
    if (!this.isValidKey(key)) {
      return fallback;
    }

    const sessionValue = this.sessionStorage.getItem(
      this.generateContextKey(key)
    );

    if (sessionValue !== undefined && sessionValue !== null) {
      return JSON.parse(sessionValue);
    }

    return fallback;
  }

  removeItem(key) {
    this.sessionStorage.removeItem(this.generateContextKey(key));
  }
}
